import React from "react";
import { TimelineItem } from "./TimelineItem";

interface TimelineCanvasProps {
  data: {
    title: string;
    items: {
      id: string;
      date?: string;
      title: string;
      description?: string;
    }[];
  };
  maxHeight?: string;
}

export const TimelineCanvas: React.FC<TimelineCanvasProps> = ({ data, maxHeight = "300px" }) => {
  const isUnbounded = maxHeight === "none";
  return (
    <div className="flex items-center justify-center p-4 bg-muted/20 rounded-xl">
      <div className="relative w-full">
        <div
          className={`relative ${isUnbounded ? "" : "overflow-y-auto overflow-x-auto overscroll-contain scrollbar-hide"}`}
          style={isUnbounded ? undefined : { maxHeight }}
        >
          <div className="relative mx-auto px-6 max-w-4xl min-w-[700px]">
            {/* Vertical line */}
            <div className="absolute inset-y-0 left-8 w-px bg-border md:left-1/2 md:-translate-x-1/2" />
            <div className="relative">
              {data.items.map((item, index) => (
                <TimelineItem key={item.id} item={item} index={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
